module.exports = __webpack_public_path__ + "static/media/Banner_500x500.793259e1.jpg";